import { render } from "./SalesReportTable.vue?vue&type=template&id=49196a27&scoped=true"
import script from "./SalesReportTable.vue?vue&type=script&lang=js"
export * from "./SalesReportTable.vue?vue&type=script&lang=js"

import "./SalesReportTable.vue?vue&type=style&index=0&id=49196a27&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49196a27"]])

export default __exports__